<template>
  <div>
    <!-- Subcategories -->
    <ul class="subcategories">
      <li v-for="(subcategory, sid) in subcategories" :key="sid">
        <a
          class="d-block d-lg-none"
          @click="openSubCategory(subcategory._id)"
        >{{subcategory.name}}</a>
      </li>
    </ul>

    <!-- Links -->
    <ul class="cat-links">
      <li v-for="(link, lid) in links" :key="lid">
        <a
          class="d-block d-lg-none"
          :href="link.url"
        >{{link.label}}</a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'LeftSubmenuView',
  props: {
    categoryId: {
      required: true,
      type: String
    },

    subcategories: {
      required: true,
      type: Array[Object],
    },

    links: {
      required: true,
      type: Array[Object],
    },

    term: {
      required: false,
      default: '',
      type: String,
    },

    close: Function,
  },

  methods: {
    openSubCategory(subcatId) {
      const query = {};
      if (this.term) query.term = this.term;
      query.categoryId = this.categoryId;
      query.subcategoryId = subcatId;

      this.$router.push({
        path: '/search',
        query: query,
      });

      this.$emit("close");
    }
  },

  computed: {},
};
</script>
